var module = angular.module('octopusApp.projects');

module.controller('ProjectProcessStepEditController',
    function ($scope, $state, $uibModal, octoDialog, $stateParams, projectState, busy, pageTitle, octopusRepository, pluginRegistry,
              octopusLog, $location, unsavedChanges, $q, actionExecutionLocations) {
        $scope.isLoading = projectState.isLoading;
        var isSaving = $scope.isSaving = busy.create();
        var projectId = $stateParams.projectId;
        $scope.project = null;
        $scope.step = null;
        $scope.environments = null;
        $scope.deploymentProcess = null;
        $scope.roles = [];
        $scope.hasFeatures = false;
        $scope.canChooseRoles = false;
        $scope.unavailableEnvironments = [];
        $scope.unavailableExcludedEnvironments = [];
        $scope.channels = null;
        $scope.executionLocations = actionExecutionLocations;
        $scope.condition = {
            environmentOption: 'all',
            inclusiveEnvironments: [],
            exclusiveEnvironments: [],
            hasHiddenEnvironments: false
        };

        $scope.actionClass = function (action) {
            return action.ActionType.replace(".", "").toLowerCase();
        };

        $scope.runsOnServer = function (action, executionLocation) {
            return action && executionLocation &&
                (executionLocation === $scope.executionLocations.alwaysOnServer ||
                (executionLocation === $scope.executionLocations.targetOrServer && action.Properties['Octopus.Action.RunOnServer'] === 'true'));
        };

        $scope.$on('actionTemplateEditor:dirty', function () {
            unsavedChanges.unsaved();
        });

        var stepId = $stateParams["stepId"];
        var actionType = $stateParams["actionType"];
        var template = $stateParams["template"];

        var findAction = function (deploymentProcess, id) {
            for (var i = 0; i < deploymentProcess.Steps.length; i++) {
                var step = deploymentProcess.Steps[i];
                for (var j = 0; j < step.Actions.length; j++) {
                    var action = step.Actions[j];
                    if (action.Id === id) {
                        return {action: action, step: step, actionIndex: j, stepIndex: i};
                    }
                }
            }
            return null;
        };

        var onLoaded = function () {

            if ($scope.action) {
                $scope.isNew = (!$scope.action.Name);
                var plugin = pluginRegistry.getDeploymentAction($scope.action.ActionType);
                if ($scope.isNew && plugin.hasPackages($scope.action) && $scope.feeds.length === 0) {
                    return $q.reject({ErrorMessage: "A NuGet package feed is required before this step can be configured. Please add a feed in the Configuration area and try again."});
                }

                // If the execution location is optional, default it to run on the target
                if ($scope.isNew && plugin.executionLocation === actionExecutionLocations.targetOrServer) {
                    $scope.action.Properties["Octopus.Action.RunOnServer"] = "false";
                }

                // If the execution location is locked, clean up the mess we've made by accidentally setting "Octopus.Action.RunOnServer" for all actions
                if (plugin.executionLocation !== actionExecutionLocations.targetOrServer) {
                    delete $scope.action.Properties["Octopus.Action.RunOnServer"];
                }

                $scope.hasFeatures = pluginRegistry.hasFeaturesForAction($scope.action.ActionType);
                $scope.executionLocation = plugin.executionLocation;
                $scope.canChooseRoles = plugin.canChooseRoles;
                $scope.isMultiAction = ($scope.step.Actions.length > 1 || $scope.step.Actions[0] !== $scope.action);
                $scope.rolesAreEditable = ($scope.step.Actions.length === 1 && $scope.step.Actions[0] === $scope.action) || $scope.step.Actions.length === 0;
                $scope.conditionIsEditable = $scope.step.Actions.length === 1 && $scope.step.Actions[0] === $scope.action || $scope.step.Actions.length === 0;
                $scope.originalActionName = $scope.action.Name || "New step";
            } else {
                $scope.canChooseRoles = true;
                $scope.hasFeatures = false;
                $scope.rolesAreEditable = true;
                $scope.conditionIsEditable = true;
            }

            var stepIndex = _.indexOf($scope.deploymentProcess.Steps, $scope.step);
            var isNotFirstStep = (stepIndex > 0 || (stepIndex < 0 && $scope.deploymentProcess.Steps.length > 0));
            $scope.conditionIsEditable = $scope.conditionIsEditable && isNotFirstStep;
            $scope.originalStepName = $scope.step.Name;

            // If we DON'T have an action, or the action does NOT have packages, we canRunBeforeAcquisition
            // Wrapping this in an object for future additions (plus this solved some weird issues with scope and directives).
            $scope.viewOptions = {
                canRunBeforeAcquisition: !$scope.action || !pluginRegistry.getDeploymentAction($scope.action.ActionType).hasPackages($scope.action),
            };

            _.each($scope.deploymentProcess.Steps, function (step, i) {
                if (!$scope.viewOptions.canRunBeforeAcquisition) {
                    return;
                }

                if (i <= stepIndex || stepIndex < 0) {
                    var hasPackages = _.any(step.Actions, function (action) {
                        var actionDefinition = pluginRegistry.getDeploymentAction(action.ActionType);
                        return actionDefinition && actionDefinition.hasPackages(action);
                    });

                    if (hasPackages) {
                        $scope.viewOptions.canRunBeforeAcquisition = false;
                    }
                }
            });

            if ($scope.action) {
                var knownEnvironments = _.map($scope.environments, function (e) {
                    return e.Id;
                });
                $scope.unavailableEnvironments = _.difference($scope.action.Environments || [], knownEnvironments);
                $scope.unavailableExcludedEnvironments = _.difference($scope.action.ExcludedEnvironments || [], knownEnvironments);

                $scope.condition.inclusiveEnvironments = _.intersection($scope.action.Environments || [], knownEnvironments);
                $scope.condition.exclusiveEnvironments = _.intersection($scope.action.ExcludedEnvironments || [], knownEnvironments);
                $scope.condition.hasHiddenEnvironments = $scope.unavailableEnvironments.length + $scope.unavailableExcludedEnvironments.length > 0;
            }

            $scope.runConditions = [
                {value: "Success", description: "Success: only run when previous steps are successful"},
                {value: "Failure", description: "Failure: only run when a previous step failed"},
                {value: "Variable", description: "Variable: only run when the variable expression is true"},
                {value: "Always", description: "Always run"}
            ];

            $scope.startTriggers = [
                {value: "StartAfterPrevious", description: "Wait for the previous step to complete, then start"},
                {value: "StartWithPrevious", description: "Run in parallel with the previous step"}
            ];
        };

        var find;
        var promises = [
            octopusRepository.Environments.all().then(function (environments) {
                $scope.environments = environments;
            }),
            octopusRepository.MachineRoles.all().then(function (machineRoles) {
                $scope.availableRoles = machineRoles;
            }),
            octopusRepository.Feeds.all().then(function (feeds) {
                $scope.feeds = feeds;
            }),
            projectState.load().then(function (project) {
                $scope.project = project;

                return $q.all(
                    [
                        projectState.deploymentProcessAsync
                            .then(function (deploymentProcess) {
                                $scope.deploymentProcess = deploymentProcess;

                                if (!actionType) {
                                    find = findAction(deploymentProcess, stepId);
                                }

                                var getTemplate;
                                if (template) {
                                    getTemplate = octopusRepository.ActionTemplates.get(template);
                                } else if (find && find.action.Properties["Octopus.Action.Template.Id"]) {
                                    getTemplate = octopusRepository.ActionTemplates.get(find.action.Properties["Octopus.Action.Template.Id"]);
                                } else {
                                    var qq = $q.defer();
                                    getTemplate = qq.promise;
                                    qq.resolve(null);
                                }

                                return getTemplate.then(function (actionTemplate) {
                                    $scope.actionTemplate = actionTemplate;
                                });

                            }),

                        octopusRepository.Projects.getChannels(project)
                            .then(function (channels) {
                                $scope.channels = channels.Items;
                            })
                    ]);
            })
        ];

        $scope.isLoading.promise($q.all(promises)).then(function () {
            if (!actionType) {
                if (find) {
                    $scope.step = find.step;
                    $scope.action = find.action;
                    pageTitle($scope.step.Name);
                } else {
                    $scope.step = _.find($scope.deploymentProcess.Steps, function (s) {
                        return s.Id === stepId;
                    });
                    $scope.action = null;
                    pageTitle($scope.step.Name);
                }
            } else {
                if (stepId) {
                    var step = _.find($scope.deploymentProcess.Steps, function (s) {
                        return s.Id === stepId;
                    });
                    if (step) {
                        $scope.step = step;
                        $scope.action = {
                            ActionType: actionType,
                            Name: "",
                            Environments: [],
                            ExcludedEnvironments: [],
                            Channels: [],
                            TenantTags: [],
                            Properties: {}
                        };

                        pageTitle("New step for: " + step.Name);
                    }
                }
                if (!$scope.step) {
                    $scope.step = {
                        Name: "",
                        Environments: [],
                        Channels: [],
                        TenantTags: [],
                        Properties: {},
                        Condition: "Success",
                        StartTrigger: "StartAfterPrevious",
                        Actions: [
                            {
                                ActionType: actionType,
                                Name: "",
                                Environments: [],
                                ExcludedEnvironments: [],
                                Channels: [],
                                TenantTags: [],
                                Properties: {}
                            }
                        ]
                    };
                    $scope.action = $scope.step.Actions[0];
                    pageTitle("New step");
                }

                if ($scope.actionTemplate) {
                    $scope.action.Name = $scope.step.Name = $scope.actionTemplate.Name;
                    $scope.action.Properties = _.clone($scope.actionTemplate.Properties);
                    $scope.action.Properties["Octopus.Action.Template.Id"] = $scope.actionTemplate.Id;
                    $scope.action.Properties["Octopus.Action.Template.Version"] = $scope.actionTemplate.Version;
                    _.each($scope.actionTemplate.Parameters, function (parameter) {
                        if (typeof parameter.DefaultValue !== 'undefined' && parameter.DefaultValue !== null && parameter.DefaultValue !== '') {

                            if (parameter.DisplaySettings['Octopus.ControlType'] === 'Sensitive') {
                                $scope.action.Properties[parameter.Name] = {
                                    HasValue: true,
                                    NewValue: parameter.DefaultValue
                                };
                                return;
                            }

                            $scope.action.Properties[parameter.Name] = parameter.DefaultValue;
                        }
                    });
                }
            }

            if (!!$scope.action) {
                if (($scope.action.Environments || []).length > 0) {
                    $scope.condition.environmentOption = 'include';
                } else if (($scope.action.ExcludedEnvironments || []).length > 0) {
                    $scope.condition.environmentOption = 'exclude';
                } else {
                    $scope.condition.environmentOption = 'all';
                }
            }

            // Provide default fallback for script templates.
            if ($scope.action && $scope.action.ActionType === 'Octopus.Script' && $scope.action.Properties && $scope.action.Properties['Octopus.Action.RunOnServer'] == null) {
                $scope.action.Properties['Octopus.Action.RunOnServer'] = 'false';
            }

            $scope.view = {editingBatchSize: $scope.step.Properties["Octopus.Action.MaxParallelism"]};
            $scope.beginEditBatchSize = function (fixed) {
                if (typeof fixed !== 'undefined') {
                    $scope.step.Properties["Octopus.Action.MaxParallelism"] = fixed;
                }
            };
            $scope.endEditBatchSize = function () {
                $scope.step.Properties["Octopus.Action.MaxParallelism"] = $scope.view.editingBatchSize;
            };
            return onLoaded();
        });

        $scope.showAddFeaturesDialog = function (action) {
            $uibModal.open({
                backdrop: true,
                keyboard: true,
                templateUrl: 'areas/projects/views/process_features_dialog.html',
                controller: 'ProjectProcessFeaturesController',
                dialogClass: 'modal modal-big',
                resolve: {
                    currentAction: function () {
                        return action;
                    },
                    currentStep: function () {
                        return $scope.step;
                    }
                }
            }).result.then(function (result) {
            });
        };

        function updateFeatures() {
            var enabledFeatureNames = ($scope.action.Properties["Octopus.Action.EnabledFeatures"] || "")
                .split(',')
                .filter(function(name){
                    return name !== "";
                });
            
            var enabledFeatures = enabledFeatureNames.map(function (f) {
                return pluginRegistry.getFeature(f);
            });

            var errors = [];

            enabledFeatures.forEach(function (feature) {
                if (feature.validate) {
                    feature.validate($scope.action, $scope.step, errors);
                }
            });
            if (errors.length > 0) {
                isSaving.showErrors("There was a problem with your request.", errors);
                return false;
            }

            pluginRegistry.getAllFeatures().forEach(function (feature) {
                if(enabledFeatureNames.indexOf(feature.featureName) === -1){
                    feature.disable($scope.action, $scope.step);
                }
            });

            enabledFeatures.forEach(function (feature) {
                if (feature.preSave) {
                    feature.preSave($scope.action, $scope.step);
                }
            });
            return true;
        }

        function updateEnvironments() {
            $scope.action.Environments = _.uniq(($scope.condition.inclusiveEnvironments || []).concat($scope.unavailableEnvironments));
            $scope.action.ExcludedEnvironments = _.uniq(($scope.condition.exclusiveEnvironments || []).concat($scope.unavailableExcludedEnvironments));

            if ($scope.condition.environmentOption !== 'include'){
                $scope.action.Environments.splice(0);
            }
            if ($scope.condition.environmentOption !== 'exclude'){
                $scope.action.ExcludedEnvironments.splice(0);
            }
        }

        $scope.save = function () {

            if ($scope.action) {
                if (!$scope.action.Name || $scope.action.Name.length === 0) {
                    if ($scope.action.Properties["Octopus.Action.Package.PackageId"]) {
                        $scope.action.Name = $scope.action.Properties["Octopus.Action.Package.PackageId"];
                    }
                }

                if(!updateFeatures()){
                    return;
                }
                updateEnvironments();
            }

            if ($scope.step.Actions.length === 1) {
                // Step name should always match action name if there is only one action
                $scope.step.Name = $scope.step.Actions[0].Name;
            }

            var applyChange = function (deploymentProcess) {
                isSaving.promise(octopusRepository.DeploymentProcesses.modify(deploymentProcess).then(function () {
                    unsavedChanges.saved();
                    $state.go('app.project.process', {projectId: $scope.project.Slug});
                }));
            };

            isSaving.promise(octopusRepository.DeploymentProcesses.get($scope.project.DeploymentProcessId).then(function (deploymentProcess) {
                if (actionType) {
                    if (stepId) {
                        var step = _.find(deploymentProcess.Steps, function (s) {
                            return s.Id === stepId;
                        });
                        step.Actions.push($scope.action);
                    } else {
                        deploymentProcess.Steps.push($scope.step);
                    }
                    applyChange(deploymentProcess);
                    return;
                }

                if ($scope.action) {
                    var find = findAction(deploymentProcess, stepId);
                    if (!find) {
                        octoDialog.messageBox("Conflict", "Someone else has deleted this step from the deployment process. Would you like to add the step back?", [{
                            result: 'yes',
                            label: 'Restore the step',
                            cssClass: 'btn-success'
                        }, {result: 'cancel', label: 'Cancel'}])
                            .then(function (result) {
                                if (result === 'yes') {
                                    var index = _.indexOf($scope.deploymentProcess.Steps, $scope.step);
                                    octopusLog.info("Inserting the step back at position: ", index);
                                    deploymentProcess.Steps.splice(index, 0, $scope.step);
                                    applyChange(deploymentProcess);
                                }
                            });
                    } else {
                        find.step.Actions[find.actionIndex] = $scope.action;
                        find.step.Name = $scope.step.Name;
                        find.step.RequiresPackagesToBeAcquired = $scope.step.RequiresPackagesToBeAcquired;
                        find.step.Condition = $scope.step.Condition;
                        find.step.StartTrigger = $scope.step.StartTrigger;
                        _.each($scope.step.Properties, function (val, key) {
                            find.step.Properties[key] = val;
                        });
                        applyChange(deploymentProcess);
                    }
                } else {
                    var originalStep = _.find(deploymentProcess.Steps, function (s) {
                        return s.Id === stepId;
                    });
                    originalStep.Name = $scope.step.Name;
                    originalStep.RequiresPackagesToBeAcquired = $scope.step.RequiresPackagesToBeAcquired;
                    originalStep.Condition = $scope.step.Condition;
                    originalStep.StartTrigger = $scope.step.StartTrigger;
                    _.each($scope.step.Properties, function (val, key) {
                        originalStep.Properties[key] = val;
                    });
                    applyChange(deploymentProcess);
                }
            }));
        };
    });












//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/controllers/project_process_step_edit_controller.js
// module id = 522
// module chunks = 1